<template>
  <div v-if="productData && Object.keys(cartProduct).length !== 0" :class="`${prefilledStylingOptions.items}  advGiftRow`">
    <div class="row row-mlr-0">
      <div class="col-12 advCartRow">
        <div class="row">
          <div :class="getCssColumnClasses('picker') + ' gift-select-checkbox'"
            v-if="enablePicker || enableMinicartPicker">
            <label class="mt-checkbox">
              <input type="checkbox"
                     value="1"
                     :checked="giftSelection"
                     @change="updateGiftSelection($event)">
              <span class="gift-select-checkbox-background"></span>
            </label>
          </div>
          <div :class="getCssColumnClasses('icon') + ' minicart-item-thumb advCartRowImg gift-row-image'">
            <div class="thumbnail_container">
              <div class="thumbnail">
                <img :src="imageSrc" :alt="productData.productName"/>
              </div>
            </div>
          </div>
          <div :class="getCssColumnClasses('caption') + ' gift-row-info'">
            <div class="row row-mlr-0 no-gutters">
              <div class="col-12 m-auto gift-row-badge">
                <span class="gift-badge">
                  {{ t('gift') }}
                  <span v-if="cartProduct.giftCountToGive || cartProduct.quantity">
                      <i class="ti-close"></i> {{ cartProduct.giftCountToGive || cartProduct.quantity }}
                  </span>!
                </span>
              </div>
              <div class="col-12 m-auto gift-row-name">
                {{ productData.productName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import giftSelectionMixin from './mixins/giftSelectionMixin'
import cartGiftOptionsMixin from './mixins/cartGiftOptionsMixin'

export default {
  name: 'AdvCartGiftRow',
  mixins: [giftSelectionMixin, cartGiftOptionsMixin],
  props: {
    cartProduct: {
      type: Object
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    productData () {
      return store.getters.getProductById(this.cartProduct.productId)
    },
    imageSrc () {
      return this.productData.hasOwnProperty('productImage') ? this.productData.productImage.list : store.getters.noImage
    }
  },
  methods: {
    getCssColumnClasses (columnType) {
      const columnTypeToIdx = {
        picker: 0,
        icon: 1,
        caption: 2
      }
      const columnIdx = columnTypeToIdx[columnType]
      let columns = {
        lg: [0, 3, 9],
        md: [0, 2, 10]
      }
      if (this.enablePicker) {
        columns = {
          lg: [2, 3, 7],
          md: [2, 2, 8]
        }
      }
      const columnClasses = []
      for (const screen of ['lg', 'md']) {
        const columnSize = columns[screen][columnIdx]
        columnClasses.push('col-' + ((screen === 'md') ? 'md' : 'lg') + '-' + columnSize)
      }
      return columnClasses.join(' ')
    }
  }
}
</script>
